export const appQueryKey = {
  getConfigurationJsonContent:
    "PRODUCT_CONFIGURATION_GETCONFIGURATION_JSON_CONTENT",
  getCurrentUserDeatils: "APP_GET_CURRRENT_USER_DETAILS",
};